import type { ObjectValuesAsTypes } from "utils/types";

export const PAYMENT_NEW_ORIGIN_PARAM = "from";

export const PAYMENT_NEW_ORIGIN = {
  ACCOUNTS: "accounts",
  PAYMENTS: "payments",
} as const;

export type PaymentNewOrigin = ObjectValuesAsTypes<typeof PAYMENT_NEW_ORIGIN>;
